import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import store from '@/store'

import { AuthApi } from '@/api/auth'
import { ILoginRequestModel, ILoginResponseModel, IResponseModelWrapper } from '@/api/typings-generated/general'

export enum UserStateAuthType {
  Windows = 'Windows',
  WebBased = 'WebBased'
}

export interface IUserState {
  token: string | null
  username: string | null
  email: string | null
  roles: string[]
  authenticationType: string | null
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token: string | null = null
  public username: string | null = null
  public email: string | null = null
  public roles: string[] = []
  public authenticationType: string | null = null

  @Mutation
  private STORE_USER(payload: ILoginResponseModel) {
    this.token = payload.userGuid
    this.username = payload.username
    this.email = payload.email
    this.roles = payload.roles
    this.authenticationType = payload.authenticationType
  }

  @Mutation
  private CLEAR_USER() {
    this.username = null
    this.email = null
    this.token = ''
    this.roles = []
    this.authenticationType = null
  }

  @Action
  public async refreshSessionData(): Promise<IResponseModelWrapper<ILoginResponseModel | null>> {
    try {
      const response = await AuthApi.status()

      if (response.isSuccessful && response.payload) {
        this.STORE_USER(response.payload)
        return response
      }

      this.CLEAR_USER()
      return {
        isSuccessful: false,
        payload: null,
        message: ''
      }
    } catch {
      this.CLEAR_USER()
      return {
        isSuccessful: false,
        payload: null,
        message: ''
      }
    }
  }

  @Action
  public async login(credentials: ILoginRequestModel)
    : Promise<IResponseModelWrapper<ILoginResponseModel | null>> {
    const response = await AuthApi.login(
      credentials.username,
      credentials.password
    )

    if (response.isSuccessful && response.payload) {
      this.STORE_USER(response.payload)
    }

    return response
  }

  @Action
  public async activeDirectoryLogin(): Promise<IResponseModelWrapper<ILoginResponseModel | null>> {
    const response = await AuthApi.loginAd()

    if (response.isSuccessful && response.payload) {
      this.STORE_USER(response.payload)
    }

    return response
  }

  @Action
  public async logout(): Promise<boolean> {
    // api call
    if (!this.token) {
      return false
    }

    const res = await AuthApi.logout()
    if (res.isSuccessful) {
      this.CLEAR_USER()
    }

    return true
  }

  get isInRole() {
    return (roles: Array<string>|string) => {
      if (typeof roles === 'string') {
        roles = [roles]
      }

      return this.roles.findIndex((r) => roles.indexOf(r) !== -1) !== -1
    }
  }
}

export const UserModule = getModule(User)
